import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SidePanel, SidePanelBody, SidePanelHeader, SidePanelFooter } from '@gpstrackit/gtc-react-controls';
import { NotificationManager } from 'Components/Notifications';
import { Loading } from 'Components';
import { IconReactMarkerRouteFSMPoint } from '../../../../../../components/Map/iconsReact'
import { ColorsToRoutePointsOnRoutesTracker } from '../../../../../../components/Map/providers/enums'
import { usePagination } from 'Components/uiControls/Table/hooks';
import {Timezone} from '../../../../../../components/uiControls';
import moment from 'moment';
import { copyToClipboard } from '../../../../../../core/data/Helpers';

import {
    Grid
} from '@mui/material';

import { Button, Container, Tabs, TabContainer, Tooltip } from '@gpstrackit/gtc-react-controls';
import { Button as ButtonCopy } from 'Components';

import { useIntl } from 'react-intl';

import {
    openModalRoutesTrackerStopInformation,
    routesTrackerGetRoutePoint,
    routesTrackerRoutePointsLogSearchRoutes
} from 'Redux/actions';

import './style.scss';

const ModalRouteStopInformation = (props) => {


    const { messages, locale } = useIntl();

    const routesTableRef = useRef();

    const dispatch = useDispatch()

    const open = useSelector(state => state.routesTrackerModalStopInformationRedux?.open);
    const routePoint = useSelector(state => state.routesTrackerModalStopInformationRedux?.routePoint);
    const routePointId = useSelector(state => state.routesTrackerModalStopInformationRedux?.routePointId);
    const loading = useSelector(state => state.routesTrackerModalStopInformationRedux?.loading);
    const routePointLogs = useSelector(state => state.routesTrackerModalStopInformationRedux?.routePointLogs);
    const loadingRoutePointLog = useSelector(state => state.routesTrackerModalStopInformationRedux?.loadingRoutePointLog);
    const timeZoneUser = useSelector((state) => state.securityRedux.user.timeZone);
    const { user: { isKph }, user } = useSelector((state) => state.securityRedux);


    useEffect(()=> {
        dispatch(routesTrackerGetRoutePoint({id: routePointId}))
        dispatch(routesTrackerRoutePointsLogSearchRoutes({pointId: routePointId}))
    },[routePointId])

    const handleToggle = () => {
        dispatch(openModalRoutesTrackerStopInformation({open: false}));
    }

    const getDate = (dateIn, timezone) => {
        let date = moment(dateIn)
        if (!date.isValid()) {
            if (dateIn && dateIn.length > 10) {
                date = moment.unix(Number(dateIn?.substring(0, dateIn.length - 3)))
            } else {
                date = moment.unix(Number(dateIn))
            }
        }
    
        if(timezone){
            date = date.tz(timezone);
        }
    
        return date;
    }

    const StopItemInfo = (props) => {
        const { label } = props
        return(
            <div style={{width: '100%'}}>
                <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        spacing={1}
                        style={{width: '100%'}}
                    >
                        <Grid item xs={4}>
                            <label className="routesTraker-stop-information-label">
                                {label}:
                            </label>
                        </Grid>
                        <Grid item xs={8}>
                            {props.children}
                        </Grid>
                </Grid>
            </div>
        )
    }


    const StopInformation = () => {
        const statusObject = ColorsToRoutePointsOnRoutesTracker.find((item) => item.name == routePoint?.status);
        return(
            <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={3} 
            >
                <Grid item style={{ width: '100%' }}>
                    <StopItemInfo label={messages['fsmRoute_routesTracker_modalInformation_Stop']}>
                        <IconReactMarkerRouteFSMPoint color={statusObject?.color || 'red'} number={routePoint?.sequence + 1} />
                    </StopItemInfo>
                </Grid>
                <Grid item style={{ width: '100%' }}>
                    <StopItemInfo label={messages['fsmRoute_routesTracker_modalInformation_name']}>
                        <div className="hover-container">
                            <label style={{ paddingRight: 5 }}>
                                {routePoint?.name || routePoint?.address}
                            </label>
                            <ButtonCopy
                                type="icon"
                                icon="content_copy"
                                onClick={() => copyToClipboard(routePoint?.name || routePoint?.address || "N/A")}
                                fontSize="inherit"
                                className="btn-no-padding hover-item"
                            />
                        </div>
                    </StopItemInfo>
                </Grid>
                <Grid item style={{ width: '100%' }}>
                    <StopItemInfo label={messages['fsmRoute_routesTracker_modalInformation_status']}>
                        <label style={{ color: statusObject?.color }}>
                            {messages[statusObject?.messages]}
                        </label>
                    </StopItemInfo>
                </Grid>
                <Grid item style={{ width: '100%' }}>
                    <StopItemInfo label={messages['fsmRoute_routesTracker_modalInformation_address']}>
                        <div className="hover-container">
                            <label style={{ paddingRight: 5 }}>
                                {`${routePoint?.address}, ${routePoint?.city}, ${routePoint?.state}`}
                            </label>
                            <ButtonCopy
                                type="icon"
                                icon="content_copy"
                                onClick={() => copyToClipboard(`${routePoint?.address}, ${routePoint?.city}, ${routePoint?.state}` || "N/A")}
                                fontSize="inherit"
                                className="btn-no-padding hover-item"
                            />
                        </div>
                    </StopItemInfo>
                </Grid>
                {
                    routePoint?.landmark?.title
                    &&
                    <Grid item style={{ width: '100%' }}>
                        <StopItemInfo label={messages['fsmRoute_routesTracker_modalInformation_landmark']}>
                            <label>
                                {routePoint?.landmark?.title}
                            </label>
                        </StopItemInfo>
                    </Grid>
                }
                <Grid item style={{ width: '100%' }}>
                    <StopItemInfo label={messages['fsmRoute_routesTracker_modalInformation_latitude_longitude']}>
                        <div className="hover-container">
                            <label style={{ paddingRight: 5 }}>
                                {`${routePoint?.latitude}, ${routePoint?.longitude}`}
                            </label>
                            <ButtonCopy
                                type="icon"
                                icon="content_copy"
                                onClick={() => copyToClipboard(`${routePoint?.latitude}, ${routePoint?.longitude}` || "N/A")}
                                fontSize="inherit"
                                className="btn-no-padding hover-item"
                            />
                        </div>
                    </StopItemInfo>
                </Grid>
                <Grid item style={{ width: '100%' }}>
                    <StopItemInfo label={messages['fsmRoute_routesTracker_modalInformation_radius']}>
                        <label>
                            {`${isKph ? (routePoint?.radius * 0.001).toFixed(2) : (routePoint?.radius * 0.000621371).toFixed(2)} ${isKph ? messages['kilometers'] : messages['miles']}`}
                        </label>
                    </StopItemInfo>
                </Grid>
                <Grid item style={{ width: '100%' }}>
                    <StopItemInfo label={messages['fsmRoute_routesTracker_modalInformation_departureTime']}>
                        {
                            routePoint?.departureTime &&
                            <Timezone
                                oneControl
                                //onlyHour
                                date={routePoint?.departureTime}
                                dateFormat={""}
                                timeFormat={"h:mm a"}
                                timezone={timeZoneUser}
                                //className="routes-tracker-TimeZoneClassName"
                                fromNow={true}
                                lang={locale}
                            /> 
                        }
                    </StopItemInfo>
                </Grid>
                <Grid item style={{ width: '100%' }}>
                    <StopItemInfo label={messages['fsmRoute_routesTracker_modalInformation_arrivalTime']}>
                        {
                            routePoint?.arrivalTime &&
                            <Timezone
                                oneControl
                                //onlyHour
                                date={routePoint?.arrivalTime}
                                dateFormat={""}
                                timeFormat={"h:mm A"}
                                timezone={timeZoneUser}
                                //className="infoBubbleTimeZoneClassName"
                                fromNow={true}
                                lang={locale}
                            /> 
                        }
                    </StopItemInfo>
                </Grid>
                
                <Grid item style={{ width: '100%' }}>
                    <StopItemInfo label={messages['fsmRoute_routesTracker_modalInformation_note']}>

                        {
                            routePoint?.note?.length > 20
                            ?
                            <Tooltip title={routePoint?.note} placement={'bottom'}>
                                <label className="routesTraker-routes-cut-text">
                                    {routePoint?.note}
                                </label>
                            </Tooltip>
                            :
                            <label className="routesTraker-routes-cut-text">
                                {routePoint?.note}
                            </label>
                        }
                    </StopItemInfo>
                </Grid>

            </Grid>
        )
    }

    const ItemStatusChangeLog = (props) => {
        const { label, isColumn } = props
        return (
            <div className={isColumn ? 'routesTraker-stop-information-item-card-content' : 'routesTraker-stop-information-item-card-content-row'}>
                <label className="routesTraker-stop-information-label">{label}:</label>
                {props.children}
            </div>
        )
    }

    const CardStopInformationLog = (props) => {
        const { item } = props
        const { status, createdOn, latitude, longitude, note, address } = item
        const statusToLog = ColorsToRoutePointsOnRoutesTracker.find((colorItem) => colorItem.name == status);
        let date = getDate(createdOn, timeZoneUser);

        let addressData = {}, strAddress = "";
        if(address){
            //{"zip": "92139", "city": "San Diego", "state": "CA", "address": "6719 Paris Way", "formatted": "6719 Paris Way, San Diego, CA 92139, USA"}
            try {
                addressData = JSON.parse(address)
                strAddress = addressData?.formatted
            } catch (error) {
                strAddress = "";
            }
            
        }

        return(
            <div className="routesTraker-stop-information-card">
                <div className="routesTraker-stop-information-card-content">
                    <ItemStatusChangeLog isColumn label={messages['fsmRoute_routesTracker_modalInformation_status']} > 
                        <div style={{ width: 100 }}>
                            <label style={{ color: statusToLog?.color }}>
                                {messages[statusToLog?.messages]}
                            </label>
                        </div>
                    </ItemStatusChangeLog>
                    <ItemStatusChangeLog label={messages['fsmRoute_routesTracker_modalInformation_createdOn']}>
                        <div style={{ width: 220 }}>
                        {
                            createdOn && date.isValid() 
                            ?
                            <Fragment>
                                <Timezone
                                    //oneControl
                                    onlyHour
                                    date={createdOn}
                                    dateFormat={""}
                                    timeFormat={"h:mm a"}
                                    timezone={timeZoneUser}
                                    className="routes-tracker-TimeZoneClassName"
                                    fromNow={true}
                                    lang={locale}
                                /> 
                                <div className='subtitle'>{date.locale(locale).format('MMM DD, YYYY')}</div>
                            </Fragment>
                            :
                            <Fragment></Fragment>
                        }
                        </div>
                    </ItemStatusChangeLog>
                    <ItemStatusChangeLog isColumn label={messages['fsmRoute_routesTracker_modalInformation_latitude_longitude_small']}>
                        <span>{`${latitude ? latitude.toFixed(4) : 0}, ${longitude ? longitude.toFixed(4) : 0}`}</span>
                    </ItemStatusChangeLog>
                    {
                        strAddress
                        &&
                        <ItemStatusChangeLog isColumn label={messages['fsmRoute_routesTracker_modalInformation_address']}>
                            <label>
                                {strAddress || ""}
                            </label>
                        </ItemStatusChangeLog>
                    }
                    
                    <ItemStatusChangeLog isColumn label={messages['fsmRoute_routesTracker_modalInformation_note']}>
                        <label>
                            {note || ""}
                        </label>
                    </ItemStatusChangeLog>
                </div>
            </div>
        )
    }

    const StatusChangeLog = () => {
        return(
            loadingRoutePointLog || loading
            ?
                <Loading overlay show />
            :
            <div className="routesTraker-stop-information-card-list">
                {
                    routePointLogs?.items 
                    &&
                    routePointLogs?.items.map((item) => {
                        return(
                            <CardStopInformationLog item={item} />
                        )
                    })
                }
                
            </div>
        )
    }

    const tabsItems = [
        {
          label: messages["fsmRoute_routesTracker_modalInformation_stop_information"],
          index: 0,
          component: <StopInformation />,
        },
        {
          label: messages["fsmRoute_routesTracker_modalInformation_status_change_log"],
          index: 1,
          component: <StatusChangeLog />,
        }
    ];

    return (
        <div id='idPanelRouteModalStopInformation'>
        <SidePanel 
            isOpen={open} 
            onToggle={handleToggle} 
            hiddenButton={false} 
            style={{ width: '400px', transform: 'translateX(400px)' }} 
        >
            <SidePanelHeader>
                <h2 style={{ margin: 0, fontFamily: '"Outfit",sans-serif' }}>{messages['fsmRoute_routesTracker_modalInformation_title']}</h2> 
            </SidePanelHeader>
            <SidePanelBody style={{ height: '90%' }}>
                {loading && <Loading overlay show /> }
                
                {
                    !loading &&
                    <div style={{ position: "absolute", left: 0, top: "25px", width: "100%" }}>
                        <Container>
                            <Tabs>
                            {tabsItems.map((item, index) => {
                                return (
                                <TabContainer key={index} label={item.label} index={item.index}>
                                    {item.component}
                                </TabContainer>
                                );
                            })}
                            </Tabs>
                        </Container>
                    </div>
                }
            </SidePanelBody>
            <SidePanelFooter>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    }}
                >
                    <Button
                        variant="secondary"
                        style={{ marginRight: 8 }}
                        onClick={handleToggle}
                    >
                        {messages['fsmRoute_routesTracker_modalInformation_close']}
                    </Button>
                </div>      
            </SidePanelFooter>
        </SidePanel>
        </div>
    )
}




export default ModalRouteStopInformation;